<template>
    <div class="modal-reclamation modal-content">
        <!-- Header -->
        <div class="modal-header border-0 p-4">
            <modal-close />

            <div class="modal-title">
                <h2 class="h3 pt-1 mb-0">
                    {{ step === 0 ? 'Reklamacja' : 'Podsumowanie' }}
                </h2>
            </div>
        </div>

        <!-- Content -->
        <reclamation-add
            v-if="step === 0"
            class="modal-reclamation__body modal-body p-4 border-top"
            :form="form"
            :error-message="errorMessage"
        />

        <reclamation-summary
            v-else-if="step = 1"
            class="modal-reclamation__body modal-body p-4 border-top"
            :form="form"
            :error-message="errorMessage"
        />

        <!-- Footer -->
        <div class="modal-footer">
            <template v-if="step === 0">
                <the-btn
                    class="btn-secondary"
                    text="Dalej"
                    :disabled="btnDisabled"
                    @click="step = 1"
                />
            </template>
            <template v-if="step === 1">
                <the-btn
                    class="btn-outline-custom"
                    text="Wróć"
                    @click="step = 0"
                />

                <the-btn
                    class="btn-secondary"
                    text="Wyślij reklamację"
                    :disabled="btnDisabled"
                    @click="sendReclamation"
                >
                    <button-spinner
                        class="ml-2"
                        :status="addReclamationLoader"
                    />
                </the-btn>
            </template>
        </div>
    </div>
</template>

<script>
import ReclamationAdd from './ReclamationAdd.vue'
import ReclamationSummary from './ReclamationSummary.vue'
import reclamationMixin from './reclamation.mixin'
import { TYPES, TYPES_DICT } from '../retr-types'
import { mapGetters } from 'vuex'

export default {
    mixins: [reclamationMixin],

    data() {
        return {
            form: {
                description: '',
                files: []
            },
            errorMessage: '',
            step: 0,
            addReclamationLoader: false
        }
    },

    computed: {
        ...mapGetters('retr', ['reclamations']),

        isFormWithValue() {
            if (this.retrData.type === TYPES.SUPPLEMENTARY_CONTRACTOR) {
                return true
            }

            if (this.retrData.type === TYPES.NETWORK_RETRO || this.retrData.type === TYPES.NETWORK_RETRO_VIP) {
                return this.retrData.element.toLowerCase() === 'wartość obrotu'
            }

            return false
        },

        btnDisabled() {
            if (this.isFormWithValue) {
                return !+this.form.value || !this.form.description
            }

            return !this.form.description
        }
    },

    methods: {
        async sendReclamation() {
            if (this.addReclamationLoader) {
                return
            }

            // Reset error message
            this.errorMessage = ''

            // Prepare payload
            const userId = this.$store.getters.userId
            const { crm_id: crmId, nip } = this.merchant
            const { type, contractor, element } = this.retrData
            const { description, value, files } = this.form
            const [quarter, year] = (this.filters.quarter.value || '').split('-')
            const attachmentList = (files || []).map(file => {
                // Return name, mimeType, fileData
                const { size, ...rest } = file

                return rest
            })

            try {
                this.addReclamationLoader = true

                const { status } = await this.$store.$api.post(`/users/${userId}/reclamation/add`, {
                    description,
                    crmId,
                    nip,
                    contractor,
                    type: TYPES_DICT[type],
                    element,
                    value,
                    attachmentList,
                    year,
                    quarter
                })

                if (status !== 200) {
                    throw new Error('Wystąpił błąd podczas dodawania reklamacji.')
                }

                // Update added reclamations in store
                const reclamation = {
                    year,
                    quarter,
                    type,
                    contractor
                }
                const reclamationExists = this.reclamations.find(rec => {
                    return +rec.year === +year &&
                        +rec.quarter === +quarter &&
                        rec.type === type &&
                        rec.contractor === contractor
                })

                if (!reclamationExists) {
                    this.$store.commit('retr/ADD_RECLAMATION', reclamation)
                }

                reclamationExists.list.push({
                    element,
                    description,
                    value,
                    files: attachmentList
                })
                this.$store.commit('retr/RESET_RECLAMATIONS', this.reclamations)

                // Close modal and show notification
                this.$store.dispatch('toggleModal', false)
                this.$store.dispatch('addNotification', {
                    type: 'success',
                    content: 'Pomyślnie wysłano reklamację'
                })
            } catch (error) {
                this.errorMessage = error.message
            } finally {
                this.addReclamationLoader = false
            }
        }
    },

    created() {
        if (this.isFormWithValue) {
            this.$set(this.form, 'value', null)
        }
    },

    components: {
        ReclamationAdd,
        ReclamationSummary
    }
}
</script>

<style lang="scss">
.modal-reclamation {
    &__body {
        display: flex;
        flex-direction: column;
        gap: 1rem;
    }

    &__file-list {
        margin-bottom: 0;
        margin-left: 0;
        padding-left: 1rem;
        color: var(--color-primary);
    }

    &__delete {
        border: 0;
        background: transparent;
        font-size: 1.25rem;
        line-height: 1;
        transform: translateY(2px);
    }

    ul {
        li {
            + li {
                margin-top: .35rem;
            }
        }
    }

    .modal-footer {
        display: flex;
        padding: .75rem 1rem;
        > * {
            flex: 1;
        }
    }

    .form-group {
        margin-bottom: 0;

        &.form-group--textarea {
            min-height: 250px;
            textarea {
                min-height: 250px;
                resize: none
            }
        }
    }
}
</style>